import { useAppSelector } from 'utils/redux/useAppSelector';
/**
 * A hook for determining whether current user is in a wrap time for a given
 * conversation.
 */
export const useCurrentUserInAcw = ({ csid, }) => {
    // NOTE: In the future we should utilize RTKQ cache to read, store, patch the
    // presence as there's no need to keep a separate slice presence. This could
    // be done when we migrate some of the legacy actions and all consumers of the
    // presence slice to use the RTKQ cache.
    const isInAcw = useAppSelector((state) => state.presence.presence.presence_status.load_descriptions.some((loadDescription) => loadDescription.load_type === 'acw' && loadDescription.csid === csid));
    return isInAcw;
};
